import { render, staticRenderFns } from "./Comp8t3.vue?vue&type=template&id=dc0ad222&scoped=true&"
import script from "./Comp8t3.vue?vue&type=script&lang=js&"
export * from "./Comp8t3.vue?vue&type=script&lang=js&"
import style0 from "./Comp8t3.vue?vue&type=style&index=0&id=dc0ad222&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0ad222",
  null
  
)

export default component.exports